module.exports = __webpack_public_path__ + "img/zoom-clips-plus.100492ac.svg";